import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const Api = createApi(config.API_URL);

export default Api;
